var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconionicIosStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.125,
    viewBox: "0 0 16 14.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M17.643,8.264H12.389l-1.6-4.53a.589.589,0,0,0-1.086,0l-1.6,4.53H2.821a.56.56,0,0,0-.571.543.38.38,0,0,0,.011.092.517.517,0,0,0,.239.384l4.318,2.893-1.657,4.58a.529.529,0,0,0,.2.611.567.567,0,0,0,.321.132.723.723,0,0,0,.357-.122l4.214-2.856,4.214,2.856a.691.691,0,0,0,.357.122.594.594,0,0,0,.514-.744l-1.657-4.58,4.282-2.92.1-.085a.559.559,0,0,0,.186-.363A.593.593,0,0,0,17.643,8.264Z",
    transform: "translate(-2.25 -3.375)",
    fill: "#fca300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicIosStar);
export default __webpack_public_path__ + "static/media/Icon ionic-ios-star.2400af124600e0e08f61984637393882.svg";
export { ForwardRef as ReactComponent };